<template>
  <FormModal
    :visible="visible"
    :title="
      pessoa.Guid ? 'Editar responsável legal' : 'Adicione um responsável legal'
    "
    :icon="require('@/assets/addRepresentante.png')"
    :loading="loading"
    :confirm-label="pessoa.Guid ? 'Atualizar' : 'Salvar'"
    @update:visible="$emit('close')"
    @confirm="salvar"
    @cancel="$emit('close')"
  >
    <form @submit.prevent="salvar">
      <!-- SUBSECTION: Dados Pessoais -->
      <div class="form-subsection">
        <h4 class="form-subsection-title">
          <i class="fa fa-user"></i>
          Dados Pessoais
        </h4>

        <div class="form-grid-1">
          <div class="form-field">
            <InputNome
              v-model="pessoa.Nome"
              label="Nome"
              :required="true"
              :erro="erros.Nome"
            />
          </div>
        </div>

        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Tipo de Documento</label
            >
            <select
              class="field"
              v-model="pessoa.TipoDocumento"
              @change="aoMudarTipoDocumento"
            >
              <option value="">Selecione</option>
              <option value="CPF">CPF</option>
              <option value="CNPJ">CNPJ</option>
              <option value="CNH">CNH</option>
              <option value="RNE">RNE</option>
            </select>
            <p v-if="erros.TipoDocumento" class="form-field-error">
              Campo obrigatório
            </p>
          </div>
          <div class="form-field">
            <label class="form-field-label form-field-label-required">{{
              obterLabelDocumento
            }}</label>
            <input
              type="text"
              class="field"
              autocomplete="off"
              v-model="pessoa.CpfCnpj"
              v-mask="obterMascaraDocumento"
              :placeholder="obterPlaceholderDocumento"
              @blur="validarDocumento"
            />
            <p v-if="erros.CpfCnpj" class="form-field-error">
              Campo obrigatório
            </p>
            <p v-if="erroDocumento" class="form-field-error">
              {{ mensagemErroDocumento }}
            </p>
          </div>
        </div>

        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >E-mail</label
            >
            <input
              type="email"
              class="field"
              autocomplete="off"
              v-model="pessoa.Email"
              @blur="validarEmail"
            />
            <p v-if="erros.Email" class="form-field-error">{{ erros.Email }}</p>
          </div>
          <div class="form-field">
            <telefone-internacional
              v-model="pessoa.Telefone"
              label="Telefone"
              name="Telefone"
              @validate="onValidateTelefone"
            />
            <p v-if="erros.Telefone" class="form-field-error">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div v-if="exibirCargo" class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Cargo</label
            >
            <input
              type="text"
              class="field"
              autocomplete="off"
              v-model="pessoa.Cargo"
            />
            <p v-if="erros.Cargo" class="form-field-error">Campo obrigatório</p>
          </div>
        </div>
      </div>

      <div class="form-subsection-divider"></div>

      <!-- SUBSECTION: Informações Regulatórias -->
      <div class="form-subsection">
        <h4 class="form-subsection-title">
          <i class="fa fa-shield"></i>
          Informações Regulatórias
        </h4>

        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Assinatura</label
            >
            <select class="field" v-model="pessoa.Assinatura">
              <option value="">Selecione</option>
              <option value="1">Não assina pela empresa</option>
              <option value="2">Assina isoladamente</option>
              <option value="0">Assina em conjunto</option>
            </select>
            <p v-if="erros.Assinatura" class="form-field-error">
              Campo obrigatório
            </p>
          </div>
        </div>

        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >É considerado US Person?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="usPerson"
                  class="form-radio-input"
                  v-model="pessoa.UsPerson"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="usPerson"
                  class="form-radio-input"
                  v-model="pessoa.UsPerson"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >É uma Pessoa Exposta Politicamente?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="politicamenteExposta"
                  class="form-radio-input"
                  v-model="pessoa.PoliticamenteExposta"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="politicamenteExposta"
                  class="form-radio-input"
                  v-model="pessoa.PoliticamenteExposta"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </FormModal>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import FormModal from "@/components/FormModal.vue";
import InputNome from "@/components/form/InputNome.vue";
import TelefoneInternacional from "@/components/TelefoneInternacional.vue";
import documentoUtils from "@/utils/documentoUtils";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";

export default {
  name: "ModalResponsavelLegal",
  components: {
    FormModal,
    InputNome,
    TelefoneInternacional,
  },
  directives: {
    mask,
  },
  mixins: [emailValidatorMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pessoaEdit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      exibirCargo: false,
      erros: {},
      erroDocumento: false,
      mensagemErroDocumento: "",
      telefoneValido: {},
      pessoa: {
        Guid: "",
        Nome: "",
        Email: "",
        Cargo: "",
        CpfCnpj: "",
        TipoDocumento: "CPF",
        Telefone: "",
        Assinatura: "",
        UsPerson: false,
        PoliticamenteExposta: false,
        Tipo: "Responsável legal", // Fixo
      },
    };
  },
  computed: {
    ...mapGetters({
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
    obterLabelDocumento() {
      return documentoUtils.obterLabelDocumento(
        this.pessoa.TipoDocumento || "CPF",
      );
    },
    obterMascaraDocumento() {
      return documentoUtils.obterMascaraDocumento(
        this.pessoa.TipoDocumento || "CPF",
      );
    },
    obterPlaceholderDocumento() {
      return documentoUtils.obterPlaceholderDocumento(
        this.pessoa.TipoDocumento || "CPF",
      );
    },
  },
  watch: {
    visible(val) {
      if (val && this.pessoaEdit) {
        this.pessoa = { ...this.pessoaEdit };
      } else if (!val) {
        this.limpar();
      }
    },
  },
  mounted() {
    this.exibirCargo =
      this.getConfiguracoes("Exibir cargo em representante")?.Valor !== "N";
  },
  methods: {
    onValidateTelefone({ name, valid }) {
      this.telefoneValido[name] = valid;
    },
    validarEmail() {
      this.validarEmailGeneric(this.pessoa.Email, "Email", {
        obrigatorio: true,
      });
    },
    aoMudarTipoDocumento() {
      this.pessoa.CpfCnpj = "";
      this.erroDocumento = false;
      this.mensagemErroDocumento = "";
    },
    validarDocumento() {
      if (this.pessoa.CpfCnpj) {
        const resultado = documentoUtils.validarDocumentoCompleto(
          this.pessoa.CpfCnpj,
          this.pessoa.TipoDocumento || "CPF",
        );
        this.erroDocumento = !resultado.valido;
        this.mensagemErroDocumento = resultado.mensagem;
      }
    },
    validar() {
      this.erros = {};
      let valido = true;

      if (!this.pessoa.Nome) {
        this.erros.Nome = true;
        valido = false;
      }
      if (!this.pessoa.TipoDocumento) {
        this.erros.TipoDocumento = true;
        valido = false;
      }
      if (!this.pessoa.CpfCnpj || this.erroDocumento) {
        this.erros.CpfCnpj = true;
        valido = false;
      }
      if (
        !this.pessoa.Email ||
        Object.values(this.emailErros || {}).some((e) => e)
      ) {
        this.erros.Email = this.emailErros?.Email || "Campo obrigatório";
        valido = false;
      }
      if (!this.pessoa.Telefone || !this.telefoneValido?.Telefone) {
        this.erros.Telefone = true;
        valido = false;
      }
      if (this.exibirCargo && !this.pessoa.Cargo) {
        this.erros.Cargo = true;
        valido = false;
      }
      if (this.pessoa.Assinatura === "" || this.pessoa.Assinatura === null) {
        this.erros.Assinatura = true;
        valido = false;
      }

      return valido;
    },
    async salvar() {
      if (!this.validar()) {
        this.$swal({
          icon: "warning",
          title: "Atenção",
          text: "Preencha todos os campos obrigatórios.",
        });
        return;
      }

      this.loading = true;
      this.$emit("submit", this.pessoa);
    },
    resetarLoading() {
      this.loading = false;
    },
    limpar() {
      this.pessoa = {
        Guid: "",
        Nome: "",
        Email: "",
        Cargo: "",
        CpfCnpj: "",
        TipoDocumento: "CPF",
        Telefone: "",
        Assinatura: "",
        UsPerson: false,
        PoliticamenteExposta: false,
        Tipo: "Responsável legal",
      };
      this.erros = {};
      this.erroDocumento = false;
      this.mensagemErroDocumento = "";
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
